var _excluded = ["block", "mobileBlock", "children", "className", "disabled", "href", "kind", "tag", "type", "icon", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import Icon from '../icons/index';
import LinkGenerator from '../link-generator';
require("./button.css");
var styles = {
  "button": "button-qfnRT",
  "buttonPrimary": "buttonPrimary-1m-xO",
  "buttonSecondary": "buttonSecondary-1ZKFx",
  "buttonTertiary": "buttonTertiary-3Og1R",
  "buttonBlock": "buttonBlock-3QinT",
  "buttonMobileBlock": "buttonMobileBlock-uR_p_",
  "iconButtonContent": "iconButtonContent-29UhU",
  "iconButtonIcon": "iconButtonIcon-3D2lQ",
  "buttonTransparent": "buttonTransparent-2Oetj",
  "iconButtonChildren": "iconButtonChildren-1-NXj"
};
var iconChildren = (children, icon) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.iconButtonContent)
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cs(styles.iconButtonIcon),
    content: icon
  }), /*#__PURE__*/React.createElement("span", null, children));
};
export var buttonKinds = ['primary', 'secondary', 'tertiary', 'transparent'];
var Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      block,
      mobileBlock,
      children,
      className,
      disabled,
      href,
      kind,
      tag,
      type,
      icon,
      onClick
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag || 'button';
  if (href && !tag) {
    Tag = LinkGenerator;
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cs(styles.button, 'lll-text-button', className, {
      [styles.buttonPrimary]: kind === 'primary',
      [styles.buttonSecondary]: kind === 'secondary',
      [styles.buttonTertiary]: kind === 'tertiary',
      [styles.buttonTransparent]: kind === 'transparent',
      [styles.buttonBlock]: block,
      [styles.buttonMobileBlock]: mobileBlock
    }),
    "aria-disabled": Tag === 'button' ? disabled : undefined,
    type: Tag === 'button' ? type : undefined,
    href: href,
    ref: ref,
    onClick: e => {
      if (disabled || !onClick) return;
      onClick(e);
    }
  }, otherProps), icon ? iconChildren(children, icon) : children);
});
Button.propTypes = {
  /** Whether to display as a block-level (full-width) button */
  block: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** Whether to add 'disabled' attribute - only supported when tag is 'button' */
  disabled: PropTypes.bool,
  /** When passed, will render a link styled to look like a button */
  href: PropTypes.string,
  /** An SVG node to be displayed at the left of the text */
  icon: PropTypes.node,
  /** Visual style of button */
  kind: PropTypes.oneOf(buttonKinds),
  /** Whether to display full-width only on mobile */
  mobileBlock: PropTypes.bool,
  /** The html tag for markup; defaults to <button> */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Value for the 'type' attribute - only supported when tag is 'button' */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /** Click handler if any */
  onClick: PropTypes.func
};
Button.defaultProps = {
  block: false,
  mobileBlock: false,
  className: null,
  disabled: false,
  href: null,
  kind: 'tertiary',
  tag: null,
  type: 'button',
  icon: null,
  onClick: undefined
};
export default Button;